import { Marker } from 'react-map-gl';

interface UserLocationMarkerProps {
  latitude: number;
  longitude: number;
}

export function UserLocationMarker({ latitude, longitude }: UserLocationMarkerProps) {
  return (
    <Marker longitude={longitude} latitude={latitude} anchor="center">
      <div className="relative">
        {/* Outer pulse animation */}
        <div className="absolute inset-0 w-6 h-6 bg-blue-500/30 rounded-full animate-ping" />
        {/* Inner circle with border */}
        <div className="relative w-6 h-6 bg-blue-500 rounded-full border-3 border-white shadow-lg flex items-center justify-center">
          <div className="w-2 h-2 bg-white rounded-full" />
        </div>
      </div>
    </Marker>
  );
}
